/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React from "react";
import Fade from "react-awesome-reveal";

export default function AllTeam({ data }) {
  // Grouping team members by their positions or hierarchy
  const grouped = {
    "General Manager": data.filter((member) =>
      member.position.toLowerCase().includes("ceo")
    ),
    "Operation Manager": data.filter(
      (member) =>
        member.position.toLowerCase().includes("manager") &&
        !member.position.toLowerCase().includes("account") &&
        !member.position.toLowerCase().includes("sales")
    ),
    "Department Heads & Supervisors": data.filter((member) =>
      ["sales", "finance", "account", "hr"].some((role) =>
        member.position.toLowerCase().includes(role)
      )
    ),
    "Architects & Engineers": data.filter(
      (member) =>
        !["ceo", "manager", "sales", "finance", "account", "hr"].some((role) =>
          member.position.toLowerCase().includes(role)
        )
    ),
  };

  return (
    <section className="container mx-auto px-4 py-16">
      {Object.entries(grouped).map(([title, members], index) => (
        <div key={index} className="mb-16">
          <Fade direction="up" triggerOnce>
            <h2 className="text-3xl font-extrabold text-green-800 mb-10 text-center">
              {title}
            </h2>
          </Fade>
          <div className={`flex flex-wrap justify-center gap-8`}>
            {members.map((member, idx) => (
              <Fade bottom triggerOnce delay={100 * idx} key={idx}>
                <div className="flex flex-col items-center w-56 h-72 rounded-xl shadow-xl border-2 border-green-600 p-4 transition-transform transform hover:scale-105">
                  <div className="flex justify-center items-center w-full h-full">
                    <img
                      src={member.imageUrl}
                      alt={member.name}
                      className="w-32 h-32 rounded-full mb-4 object-cover"
                    />
                  </div>
                  <h3 className="text-green-800 text-lg font-semibold text-center">
                    {member.name}
                  </h3>
                  <p className="text-gray-500 text-sm text-center">
                    {member.position}
                  </p>
                </div>
              </Fade>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
